"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundError = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const HttpError_1 = require("./HttpError");
class NotFoundError extends HttpError_1.HttpError {
    constructor(item = 'item', msg, functionalErrors, metaData) {
        const message = msg ?? `The requested ${item} does not exist`;
        super(404, `${item.toLowerCase()}_not_found`, message, functionalErrors, metaData);
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 404, description: 'HTTP Code' }),
    tslib_1.__metadata("design:type", Number)
], NotFoundError.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'bucket_not_found', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], NotFoundError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'The requested bucket endpoint s3://bucket/name does not exist',
        description: 'Message describing what cannot be found.',
    }),
    tslib_1.__metadata("design:type", String)
], NotFoundError.prototype, "message", void 0);
exports.NotFoundError = NotFoundError;
